function adjustLongText() {
    const seperateSomethingInLongText: (
        text: string,
        limitLengthText?: number,
        charactor?: string,
    ) => string = (
        text: string,
        lengthOfText: number = 20,
        charactor = '\n',
    ) => {
        // base case: when text not longger length of split text should return itselfs.
        if (text.split(charactor)[0].length < lengthOfText) {
            return text
        }
        // another case: insert "new charactor" on long text
        else {
            let firstCharacter = text.slice(0, lengthOfText)
            let endCharacter = text.slice(lengthOfText) || ''
            return (
                firstCharacter +
                charactor +
                seperateSomethingInLongText(
                    endCharacter,
                    lengthOfText,
                    charactor,
                )
            )
        }
    }

    return { seperateSomethingInLongText }
}
export default adjustLongText
